import React, { useState } from "react";
import "./AutomationDiverse.css";
import img1 from '../autoassets/diverse1.png';
import img2 from '../autoassets/diverse2.png';
import img3 from '../autoassets/diverse3.png';
import img4 from '../autoassets/diverse4.png';
import img5 from '../autoassets/diverse5.png';
import img6 from '../autoassets/diverse6.png';

export default function AutomationDiverse() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      img: img1,
      id: 1,
      title: "Assessment",
      description:
        "Streamline your Azure DevOps infrastructure by automating CI/CD pipelines and running continuous tests right from the start of the software development lifecycle",
    },
    {
      img: img2,
      id: 2,
      title: "Proposal",
      description:
        "Integrate your AWS DevOps development process with best-in-class automation tools to reduce potential bugs and create robust cloud applications",
    },
    {
      img: img3,
      id: 3,
      title: "Due Diligence",
      description:
        "Cut down the scope of human intervention so that you can decrease the number of possible errors by thoroughly automating your build and deployment process",
    },
    {
      img: img4,
      id: 4,
      title: "Contract Procurement",
      description:
        "Embrace DevOps automation best practices and strategies to facilitate an efficient workflow in your business and reduce manual, time-consuming workload",
    },
    {
      img: img5,
      id: 5,
      title: "Implementation",
      description:
        "Simplify your development tasks and make the entire ecosystem faster and more productive by enabling comprehensive DevOps process automation",
    },
    {
      img: img6,
      id: 6,
      title: "Management",
      description:
        "Take your deployment and release game to new heights with the required speed, agility, and reliability through a continuous delivery automation plan",
    },
  ];

  return (
    <div id="automation-diverse" className="outsourcemainclass">
      <div className="top">
        <h2 className="heading">
         Computer Vision Solutions for Diverse Industries
        </h2>
        <p className="subheading">
          Our DevOps engineers automate deployments using workflow and test
          automation to improve efficiency, reliability, and collaboration
          across the DevOps lifecycle.{" "}
        </p>
      </div>
      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <img src={card.img} alt="error" />
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <img src={card.img} alt="error" />
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
